/**
 * @author Sarthak Sharma.
 * @since 31-01-2024.
 * @type {string} Profile Category action types.
 */

export const SET_LOADING = '[RECRUITER_GENERAL] SET_LOADING';
export const SET_PROFILE_CATEGORY_LIST = '[RECRUITER_GENERAL] SET_PROFILE_CATEGORY_LIST';
export const SET_LOCATION_LIST = '[RECRUITER_GENERAL] SET_LOCATION_LIST';
export const SET_PROJECT_CATEGORY_LIST = '[RECRUITER_GENERAL] SET_PROJECT_CATEGORY_LIST';
export const SET_ROLE_TYPE_LIST = '[RECRUITER_GENERAL] SET_ROLE_TYPE_LIST';

export const SET_REPORT_TYPE_LIST = '[RECRUITER_GENERAL] SET_REPORT_TYPE_LIST';
export const SET_REPORT_MODAL = '[RECRUITER_GENERAL] SET_REPORT_MODAL';
export const SET_KYC_MODAL = '[RECRUITER_GENERAL] SET_KYC_MODAL';

